export const COMPANYINFO_LOCALSTORAGE_KEY = 'companyInfo';
export const ACCESSTOKEN_LOCALSTORAGE_KEY = 'accessToken';
export const LS_KEY_MENU_COLLAPSE_STATE = 'isCollapsed';
export const LNG_LOCALSTORAGE_KEY = 'i18nextLng';
export const PROFILE_LOCALSTORAGE_KEY = 'profile';
export const LS_PINFL = 'pinfl';
export const LS_TIN = 'tin';
export const LS_CONCLUSION_FORM_DATA = 'conclusionFormData';
